import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const pickupSettingsAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.PickupSettingsPickupSettingsView,
      Permission.PickupSettingsPickupSettingsModify,
    ],
  },
]
